var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    transform: "matrix(-1 0 0 1 23 0)",
    fill: "white",
    stroke: "#DDDDDD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.07716 8.06404L10.2857 6.85547L15.4286 11.9983L10.2857 17.1412L9.07716 15.9326L13.0029 11.9983L9.07716 8.06404Z",
    fill: "#020204"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollarrow);
export default __webpack_public_path__ + "static/media/scrollarrow.37a7e2c9f65a4e1664d68045fbab4342.svg";
export { ForwardRef as ReactComponent };